<template>
  <div id="pageRoot">
    <div class="tag" style="left: 60px; top: 260px; z-index: 3">
      <p class="textBase tagText">VENANCIO</p>
    </div>

    <div class="tag" style="right: 80px; top: 260px; z-index: 3">
      <p class="textBase tagText">DON FITO</p>
    </div>

    <p id="text01">PONÍA EL DEDO EN ALTO Y GRITABA.</p>
    <p id="text02">NO VOLABA COMO UNA MARIPOSA.</p>

    <!-- TEXT ----------------------------------------------------------------------------------------------------->
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <!-- TEXT ----------------------------------------------------------------------------------------------------->
    <div id="dog" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage59Dog.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>
    <div id="donFito" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage58DonFito.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>
    <div id="dogfooter" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage59Dog.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <span class="footer-page footer-write"></span>
    <span id="fixedBackground" class="pageElement"></span>
    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
  </div>
</template>
<style scoped>
.tag {
  position: absolute;
  width: 310px;
  height: 70.55px;

  background-image: url(/pages/img/sordo/svgPage75TagMedium.svg);
  background-size: contain;
  background-repeat: no-repeat;
  transform: scale(0.6);
  transition: 0.3s;
}
#fixedBackground {
  position: absolute;
  width: 940px;
  height: 544px;
  left: 47px;
  top: 32px;
  background-image: url(/pages/img/sordo/svgPage58B.svg);
}
#dog {
  position: absolute;
  width: 158.79px;
  height: 150.68px;
  left: 242px;
  top: 210px;
}
#donFito {
  position: absolute;
  width: 135.71px;
  height: 283.63px;
  left: 602px;
  top: 71px;
}
#dogfooter {
  position: absolute;
  width: 346px;
  height: 324.37px;
  left: 56px;
  top: 570px;
}
#txtVenancio {
  /* VENANCIO */

  position: absolute;
  width: 120px;
  height: 70px;
  left: 136px;
  top: 257px;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 70px;
  /* identical to box height, or 292% */
  text-transform: uppercase;

  color: #ffffff;
}
#txtDonfito {
  /* DON FITO */

  position: absolute;
  width: 112px;
  height: 70px;
  left: 720px;
  top: 260px;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 70px;
  /* identical to box height, or 292% */
  text-transform: uppercase;

  color: #ffffff;
}
#inputField01 {
  width: 410px;
  margin-left: 55%;
  margin-top: 36.5%;
  position: absolute;
  z-index: 3;
}
#inputField02 {
  width: 420px;
  margin-left: 54%;
  margin-top: 45.2%;
  position: absolute;
  z-index: 3;
}

#text01 {
  /* PONÍA EL DEDO EN ALTO Y GRITABA. */

  position: absolute;
  width: 504px;
  height: 60px;
  left: 48px;
  top: 378px;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  line-height: 70px;
  /* or 233% */
  text-transform: uppercase;

  color: #000000;
}
#text02 {
  /* NO VOLABA COMO UNA MARIPOSA. */

  position: absolute;
  width: 516px;
  height: 60px;
  left: 48px;
  top: 468px;
  margin: 0px;
  z-index: 3;

  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  line-height: 70px;
  /* or 233% */
  text-transform: uppercase;

  color: #000000;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p59/V26.mp4", "p59/V27.mp4"],
    };
  },
};
</script>